import { ArrowUpBoldHexagonOutlineIcon } from './ArrowUpBoldHexagonOutlineIcon';

/**
 * author: Austin Andrews
 * id 7C3BD067-49AB-41C8-9091-FBD2D533045E
 * name arrow-up-bold-hexagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-hexagon-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopBoldHexagonOutlineIcon = ArrowUpBoldHexagonOutlineIcon;
export default ArrowTopBoldHexagonOutlineIcon